import React, { useState } from 'react';

import { ArrowInCircleRightIcon } from '@vlabs/icons';
import { EmptyImage } from '@vlabs/shared/components/empty-image';
import { Sample } from '@vlabs/shared/components/sample/Sample';
import { routes } from '@vlabs/shared/navigation/routes';
import { CircleAnimatedButton } from '@vlabs/uikit';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import st from './MatchItem.module.sass';

export const MatchItem = ({
  avatar,
  faceId,
  children,
  className,
}) => {
  const { t } = useTranslation();

  const [isEmpty, setIsEmpty] = useState(!avatar);

  return (
    <div className={cn(st.MatchItem__Root, className)}>
      <div className={st.Image__Wrapper}>
        {avatar && !isEmpty && (
          <Sample className={st.Image} image={avatar} onError={() => setIsEmpty(true)} />
        )}
        {isEmpty && <EmptyImage className={st.Image} />}

        <div className={st.MatchLink__Wrapper}>
          <CircleAnimatedButton
            as="a"
            data-testid="MatchItem.goToFacePage"
            href={generatePath(routes.facePage, { faceId })}
            icon={<ArrowInCircleRightIcon />}
            rel="noopener noreferrer"
            size="small"
            target="_blank"
          >
            {t('monokit:create_face.face_details')}
          </CircleAnimatedButton>
        </div>
      </div>
      {children}
    </div>
  );
};

MatchItem.propTypes = {
  avatar: PropTypes.string,
  faceId: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

MatchItem.defaultProps = {
  avatar: undefined,
  faceId: undefined,
  className: undefined,
  children: undefined,
};
